import PLACEHOLDERS from 'jsx/constants/placeholders';
import UTILS from 'jsx/constants/utils';
import { validateDate } from 'jsx/utils/form/validations';

const INFORMATION_REQUEST_FIELDS = {
  firstname: {
    label: 'Patient’s First Name',
    placeholder: PLACEHOLDERS.firstname,
    rules: 'required|string',
  },
  lastname: {
    label: 'Patient’s Last Name',
    placeholder: PLACEHOLDERS.lastname,
    rules: 'required|string',
  },
  date_of_birth: {
    label: 'Date of Birth',
    placeholder: PLACEHOLDERS.date,
    rules: 'required|string',
    validators: [validateDate],
  },
  address1: {
    label: 'Shipping Address',
    placeholder: PLACEHOLDERS.address1,
    rules: 'required|string',
  },
  address2: {
    name: 'address2',
    label: 'Apartment/other',
    placeholder: PLACEHOLDERS.address2,
    rules: 'string',
  },
  city: {
    label: 'City',
    placeholder: PLACEHOLDERS.city,
    rules: 'required|string',
  },
  zipcode: {
    label: 'Zip Code',
    placeholder: PLACEHOLDERS.zipcode,
    extra: { hint: '•••••' },
    rules: ['required', `regex:${UTILS.REGEX_ZIPCODE_VALIDATION}`],
  },
  phone: {
    label: 'Phone',
    placeholder: PLACEHOLDERS.phone,
    extra: { hint: '••• ••• ••••' },
    rules: ['required', `regex:${UTILS.REGEX_PHONE_VALIDATION}`],
  },
  email: {
    label: 'Email',
    placeholder: PLACEHOLDERS.email,
    rules: `email|string|required`,
  },
};

export default INFORMATION_REQUEST_FIELDS;
